if (typeof FeaturedCollectionsToggleTabs !== "function") {
  class FeaturedCollectionsToggleTabs extends HTMLElement {
    constructor() {
      super();

      this.titleEl = this.querySelectorAll("[data-js-tc-title]");
      this.contentEl = this.querySelectorAll("[data-js-tc-content]");
      this.logoEl = this.querySelectorAll(".toggle__collab-logo[data-collection]");
      
      this.titleEl.forEach((title) => {
        title.addEventListener("click", this.onClickHandler.bind(this, title));
      });

      this.titleEl.forEach((title) => {
        title.addEventListener("keydown", (e) => {
          if (e.keyCode == window.KEYCODES.RETURN) {
            this.onClickHandler();
          };
        });
      });
    };

    onClickHandler(selectedTitle) {

      let currentVisibleTitle = selectedTitle.getAttribute("data-collection");
      let currentVisibleContent;

      this.titleEl.forEach((title) => {
        if (title.getAttribute("data-collection") === currentVisibleTitle) {
          title.classList.add("visible");
          const container = title.closest(".collection-toggles-container");
          if (container) {
            title.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
          }
        } else {
          title.classList.remove("visible");
        };
      });

      this.logoEl.forEach((logo) => {
        if (currentVisibleTitle === logo.getAttribute("data-collection")) {
          logo.style.display = "";
        } else {
          logo.style.display = "none";
        };
      });

      this.contentEl.forEach((content) => {
        if (currentVisibleTitle === content.getAttribute("data-collection")) {
          currentVisibleContent = content.getAttribute("data-collection");
          content.classList.add("visible");
          content.style.removeProperty("display");
          let display = window.getComputedStyle(content).display;
          if (display === "none") {
            display = "block";
          };
          content.style.display = display;
          content.querySelector('css-slider')?.resetSlider();
        } else {
          content.classList.remove("visible");
          content.style.removeProperty("display");
          let display = window.getComputedStyle(content).display;
          if (display === "block") {
            display = "none";
          };
          content.style.display = display;
        };
      });
    };
  };

  if (typeof customElements.get("toggle-collections-tabs") == "undefined") {
    customElements.define(
      "toggle-collections-tabs",
      FeaturedCollectionsToggleTabs,
    );
  };
};